import head from "lodash/head";
import drop from "lodash/drop";
import get from "lodash/get";
import React from "react";
import { ResponsiveHeroImage } from "@quintype/components";
import { loadRelatedStories } from "./related-stories-helper";
import { ImageFallback } from "../basic/image-fallback.js";
import {altTagOfHeroImages, isExternalStory} from "../../utils";

function getImageFallback (props) {
  const story = props.story && props.story.story ? props.story.story : props.story;
  if(!props.showImage) return null;
      return (props.showImage && props.story["hero-image-s3-key"]) ? <figure className="story-card-image">
          <ResponsiveHeroImage story={story}
            aspectRatio={[4,3]}
             alt={altTagOfHeroImages(props.story)}
            defaultWidth={480} widths={[250,480,640]} sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 23%"
            imgParams={{auto:['format', 'compress'], fit:'max'}}/>
        </figure> : <ImageFallback className="story-card__image story-card__image--cover"/> 
}

function RelatedStoryCard(props){
  const classname = props.showImage ? 'story-title story-title-bold' : 'story-title';
  const externalLink = isExternalStory(props.story);
  // The `props.story` can be an item from items of a collection or a story itself.
  // assigning it accordinlgy.
  return !props.story ? null : <div className="related_stories-story-card">
    <a href={externalLink ? externalLink : `/${props.story.slug}`} target={externalLink ? '_blank' : '_self'}>
      {getImageFallback(props)}
      <h2 className={classname}><bdi dangerouslySetInnerHTML={ {__html: props.story.headline }}></bdi></h2>
        <div className="author-title">
          {get(props.story, ['authors', 0, 'name'], props.story['author-name'])}
        </div>
    </a>
  </div>
}

class RelatedStories extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      relatedStories: []
    };
  }

  updateRelatedStories(story) {
    loadRelatedStories(story)
      .then(relatedStories => {
        this._isMounted && this.setState({
          relatedStories: relatedStories
        });
      });
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateRelatedStories(this.props.story)
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return !this.state.relatedStories || !this.state.relatedStories.length ? null : <div className="related_stories" data-testid = "related-stories">
      <h4 className="related_stories-heading"> Related Stories </h4>
      <RelatedStoryCard story={head(this.state.relatedStories)} showImage={true}/>
      {drop(this.state.relatedStories).map(story => <RelatedStoryCard key={story.id} story={story} showImage={false} />)}
    </div>
  }
}

export { RelatedStories };
